import { jsonp } from '../../../../base/base/index';

/* 获取文章评论数 */
export const getCommentCount = async function getCommentCount(url) {
    const commentDomain =  typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__: 'c01049em.ifeng.com';

    return await jsonp(`//${commentDomain}/get.php`, {
        data: {
            job: 4,
            format: 'js',
            docurl: url.join('|'),
        },
        jsonpCallback: 'getAllComment1',
        cache: false,
    });
};

// 获取视频播放数
export const getVideoPlayNum = async vid => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data.browse;

    return data ? data : null;
};
